import FormControlLabel from "@material-ui/core/FormControlLabel";
import StyledCheckbox from "../../../../../utils/componentutils/StyledCheckbox";
import Typography from "@material-ui/core/Typography";
import React from "react";

export default function RestartOncePositionHasFlattenedComponent({top, dispatchTop}) {
    return <FormControlLabel
        value="top"
        control={
            <StyledCheckbox
                color="primary"
                checked={top.restartSystemOncePositionHasFlattened}
                onChange={(ev) =>
                    dispatchTop({restartSystemOncePositionHasFlattened: ev.target.checked})
                }
            />
        }
        label={<Typography style={{fontSize: 10}}>repeating</Typography>}
        labelPlacement="bottom"
    />
}